<template>
    <form @change="isFormDirty" @submit.prevent="handleSubmit" class="form-container p-4" data-cy="form-container">
        <p class="text-center text-default-red p-2" v-if="validation.message">
            {{ validation.message }}
        </p>
        <div class="form-section" data-cy="section-general">
            <div class="form-section-header borderline mb-4">
                <div data-cy="admin-settings-general-title">{{ $t('admin.general.title') }}</div>
                <a-button-group>
                    <a-button data-cy="submit-button" class="button-submit" @click="handleSubmit" :loading="processing">
                        {{ $t('admin.general.submit') }}
                    </a-button>
                    <a-button data-cy="btn-update-cache" @click="onUpdateCache" :loading="update_cache_processing">
                        {{ $t('admin.general.update_cache') }}
                    </a-button>
                </a-button-group>
            </div>
            <div class="section-body">
                <div class="input-container mb-2 pr-4 lg:w-1/2 md:w-1/2" data-cy="admin-settings-kb-url">
                    <ui-label>{{ $t('admin.general.kb_url') }}</ui-label>
                    <ui-input
                        v-model="v$.site_management.kb_url.$model"
                        :class="{ 'form-error': v$.site_management.kb_url.$error }"
                    />
                    <div
                        class="w-full mb-2"
                        data-cy="field-kb-url-error"
                        :class="{ 'text-default-red': v$.site_management.kb_url.$error }"
                        v-if="v$.site_management.kb_url.required.$invalid && v$.site_management.kb_url.$error"
                    >
                        {{ $t('validation.required') }}
                    </div>
                    <validation-errors :errors="validation.errors.name" v-if="validation.errors"></validation-errors>
                </div>
                <div class="input-container mb-2 pr-4 lg:w-1/2 md:w-1/2" data-cy="admin-settings-kb-token">
                    <ui-label>{{ $t('admin.general.kb_token') }}</ui-label>
                    <ui-input
                        v-model="v$.site_management.kb_token.$model"
                        :class="{ 'form-error': v$.site_management.kb_token.$error }"
                    />
                    <div
                        class="w-full mb-2"
                        data-cy="field-kb-token-error"
                        :class="{ 'text-default-red': v$.site_management.kb_token.$error }"
                        v-if="v$.site_management.kb_token.required.$invalid && v$.site_management.kb_token.$error"
                    >
                        {{ $t('validation.required') }}
                    </div>
                    <validation-errors :errors="validation.errors.name" v-if="validation.errors"></validation-errors>
                </div>
                <div class="input-container mb-2 pr-4 lg:w-1/3 md:w-1/2" data-cy="admin-settings-kb-name">
                    <ui-label>{{ $t('admin.general.kb_name') }}</ui-label>
                    <ui-input
                        v-model="v$.site_management.kb_name.$model"
                        :class="{ 'form-error': v$.site_management.kb_name.$error }"
                    />
                    <div
                        class="w-full mb-2"
                        data-cy="field-kb-name-error"
                        :class="{ 'text-default-red': v$.site_management.kb_name.$error }"
                        v-if="v$.site_management.kb_name.required.$invalid && v$.site_management.kb_name.$error"
                    >
                        {{ $t('validation.required') }}
                    </div>
                    <validation-errors :errors="validation.errors.name" v-if="validation.errors"></validation-errors>
                </div>
                <div class="input-container mb-2 pr-4 lg:w-1/3 md:w-1/2" data-cy="admin-settings-kb-username">
                    <ui-label>{{ $t('admin.general.kb_username') }}</ui-label>
                    <ui-input
                        v-model="v$.site_management.kb_username.$model"
                        :class="{ 'form-error': v$.site_management.kb_username.$error }"
                    />
                    <div
                        class="w-full mb-2"
                        data-cy="field-kb-username-error"
                        :class="{ 'text-default-red': v$.site_management.kb_username.$error }"
                        v-if="v$.site_management.kb_username.required.$invalid && v$.site_management.kb_username.$error"
                    >
                        {{ $t('validation.required') }}
                    </div>
                    <validation-errors :errors="validation.errors.name" v-if="validation.errors"></validation-errors>
                </div>
                <div class="input-container mb-2 pr-4 lg:w-1/3 md:w-1/2" data-cy="admin-settings-kb-email">
                    <ui-label>{{ $t('admin.general.kb_email') }}</ui-label>
                    <ui-input
                        v-model="v$.site_management.kb_email.$model"
                        :class="{ 'form-error': v$.site_management.kb_email.$error }"
                    />
                    <div
                        class="w-full mb-2"
                        data-cy="field-kb-email-error"
                        :class="{ 'text-default-red': v$.site_management.kb_email.$error }"
                        v-if="v$.site_management.kb_email.required.$invalid && v$.site_management.kb_email.$error"
                    >
                        {{ $t('validation.required') }}
                    </div>
                    <div
                        data-cy="field-kb-email-format-error"
                        :class="{ 'text-default-red': v$.site_management.kb_email.$error }"
                        v-if="
                            v$.site_management.kb_email.email.$invalid &&
                            v$.site_management.kb_email.$error &&
                            !v$.site_management.kb_email.required.$invalid
                        "
                    >
                        {{ $t('validation.email', { attribute: $t('admin.general.kb_email') }) }}
                    </div>
                    <validation-errors :errors="validation.errors.name" v-if="validation.errors"></validation-errors>
                </div>
                <div
                    class="input-container mb-2 pr-4 lg:w-1/4 md:w-1/2"
                    data-cy="admin-settings-claimsvault-analytics-url"
                >
                    <ui-label>{{ $t('admin.general.claimsvault_analytics_url') }}</ui-label>
                    <ui-input v-model="site_management.claimsvault_analytics_url" />
                </div>
                <div
                    class="input-container mb-2 pr-4 lg:w-1/4 md:w-1/2"
                    data-cy="admin-settings-covervault-analytics-url"
                >
                    <ui-label>{{ $t('admin.general.covervault_analytics_url') }}</ui-label>
                    <ui-input v-model="site_management.covervault_analytics_url" />
                </div>
                <div class="input-container mb-2 pr-4 lg:w-1/4 md:w-1/2" data-cy="admin-settings-import-batch-size">
                    <ui-label>{{ $t('admin.general.import_batch_size') }}</ui-label>
                    <ui-input-number :min="0" :max="2000" v-model="v$.site_management.import_batch_size.$model" />
                </div>
                <div
                    class="input-container mb-2 pr-4 lg:w-1/4 md:w-1/2"
                    data-cy="admin-settings-max-number-of-import-processes"
                >
                    <ui-label>{{ $t('admin.general.max_number_of_import_processes') }}</ui-label>
                    <ui-input-number
                        :min="1"
                        :max="10"
                        v-model="v$.site_management.max_number_of_import_processes.$model"
                    />
                </div>
                <div class="input-container mb-2 pr-4 lg:w-1/4 md:w-1/2" data-cy="admin-settings-max-file-process-time">
                    <ui-label>{{ $t('admin.general.max_file_process_time') }}</ui-label>
                    <ui-input-number :min="0" v-model="v$.site_management.max_file_process_time.$model" />
                </div>
            </div>
        </div>
        <div class="form-section" data-cy="section-cover">
            <div class="form-section-header borderline mb-2">
                <div data-cy="admin-settings-cover">
                    {{ $t('admin.general.title_cover') }}
                </div>
            </div>
            <div class="section-body">
                <div class="input-container mb-2 pr-4 lg:w-1/3 md:w-1/2" data-cy="admin-settings-cover-print-limit">
                    <ui-label>{{ $t('admin.general.cover_print_limit') }}</ui-label>
                    <ui-input-number :min="1" :max="10" v-model="v$.site_management.cover_print_limit.$model" />
                </div>
            </div>
        </div>
        <div class="form-section mb-12" data-cy="section-flags">
            <div class="form-section-header borderline mb-2">
                <div data-cy="admin-settings-flags">
                    {{ $t('admin.general.title_flags') }}
                </div>
            </div>
            <div class="section-body">
                <div data-cy="admin-settings-is-enfoce-filename-restriction" class="input-container pr-4 w-1/2">
                    <ui-checkbox v-model="site_management.is_enforce_filename_restriction">
                        {{ $t('admin.general.is_enforce_filename_restriction') }}
                    </ui-checkbox>
                </div>
                <div data-cy="admin-settings-is-modules-enabled" class="input-container pr-4 w-1/2">
                    <ui-checkbox v-model="site_management.is_modules_enabled">
                        {{ $t('admin.general.is_modules_enabled') }}
                    </ui-checkbox>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import UiCheckbox from '@/components/ui/Checkbox.vue';
import UiInput from '@/components/ui/Input.vue';
import UiInputNumber from '@/components/ui/InputNumber.vue';
import UiLabel from '@/components/ui/Label.vue';
import UiSubmitButton from '@/components/ui/SubmitButton.vue';
import ValidationErrors from '@/components/ui/ValidationErrors.vue';

import { useVuelidate } from '@vuelidate/core';
import { email, required } from '@vuelidate/validators';

export default {
    setup() {
        return { v$: useVuelidate() };
    },
    components: {
        UiCheckbox,
        UiInput,
        UiInputNumber,
        UiLabel,
        UiSubmitButton,
        ValidationErrors,
    },
    data() {
        return {
            form_dirty: false,
            processing: false,
            update_cache_processing: false,
            validation: {
                errors: {},
                message: '',
            },
        };
    },
    props: {
        site_management: Object,
    },
    validations: {
        site_management: {
            kb_url: { required },
            kb_name: { required },
            kb_username: { required },
            kb_token: { required },
            kb_email: { required, email },
            is_enforce_filename_restriction: {},
            is_modules_enabled: {},
            cover_print_limit: {},
            import_batch_size: {},
            max_number_of_import_processes: {},
            max_file_process_time: {},
        },
    },
    methods: {
        isFormDirty(is_dirty) {
            this.form_dirty = is_dirty;

            this.$emit('is-form-dirty', is_dirty);
        },
        async handleSubmit() {
            if (!(await this.v$.$validate())) return false;

            if (this.processing) {
                return false;
            }

            this.processing = true;

            let payload = {
                ...this.site_management,
            };

            this.$http
                .post('/api/management', payload)
                .then((response) => {
                    if (response.data.status == 'success') {
                        this.$store.dispatch('system/updateEpicVaultModule', payload.is_modules_enabled);
                        this.$notification.success({ message: response.data.message });

                        this.isFormDirty(false);
                    } else {
                        this.$notification.error({
                            message: response.data.message,
                        });
                    }
                })
                .catch((error) => {
                    if (error.response.status == 422) {
                        this.$notification.error({
                            message: error.response.data.message,
                        });

                        this.validation = error.response.data;
                    } else if (error.response.status == 403) {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.403_mod'),
                        });
                    } else {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.any', { code: 'CVSMU01' }),
                        });
                    }
                })
                .finally(() => {
                    this.processing = false;
                });
        },
        onUpdateCache() {
            if (this.update_cache_processing) {
                return false;
            }

            this.update_cache_processing = true;

            this.$http
                .post('/api/management/update-cache')
                .then((response) => {
                    if (response.data.status == 'success') {
                        this.$confirm({
                            title: this.$t('admin.update_cache_modal.title'),
                            content: this.$t('admin.update_cache_modal.content'),
                            onOk() {
                                window.location.reload();
                            },
                        });
                    } else {
                        this.$notification.error({
                            message: response.data.message,
                        });
                    }
                })
                .catch((error) => {
                    if (error.response.status == 403) {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.403_mod'),
                        });
                    } else {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.any', { code: 'CVSMC01' }),
                        });
                    }
                })
                .finally(() => {
                    this.update_cache_processing = false;
                });
        },
    },
};
</script>
